<template>
  <div class="result">
    <h4>
      <a @click="view" class="link">
        {{ result.title || result._id }}
      </a>
    </h4>
    <h5>
      {{ result.author }}
    </h5>
    <div style="font-size: 11px;">
      {{ result.langs }}
      {{ result.src }}
      {{ result.url }}
      {{ result.filename ? result.filename.split('/').slice(-1)[0] : '' }}
    </div>
    <div v-html="'... ' + result.text + ' ...'"></div>
  </div>
</template>

<script>
export default {
  props: ['result', 'query'],

  methods: {
    view() {
      this.$router.push({
        name: 'view',
        params: {
          col: this.result._id.split('/')[0],

          _key: this.result._id.split('/')[1],
        },
        query: { query: JSON.stringify(this.query) },
      })
    },
  },
}
</script>

<style scoped>
h4,
h5 {
  padding: 3px;
  margin: 3px;
}

.result {
  margin: 3px;
  padding: 5px;
  color: #111;
  background-color: #eaf4ea;
}
.bold {
  font-weight: bold;
}
</style>
